<template>
    <div>
        <app-erros-box :erros="erros2" v-if="erros2.length > 0"></app-erros-box>
        <app-tabela
            :itens="requisicaoComprometimentos"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <btn-inserir-rateio-requisicao
                        ref="inserirRateioRequisicao"
                        :requisicao="requisicao"
                        :erros="erros"
                        @inserirRateio="inserirRateio($event)"
                        v-if="permiteInserirRateio"
                    ></btn-inserir-rateio-requisicao>
                    <btn-comprometer-selecionados
                        :requisicao="requisicao"
                        :comprometimentosSelecionados="
                            selecionadosParaComprometer
                        "
                        @comprometerSelecionados="comprometerSelecionados"
                    ></btn-comprometer-selecionados>
                    <btn-descomprometer-selecionados
                        :requisicao="requisicao"
                        :comprometimentosSelecionados="selecionadosParaDescomprometer"
                        @descomprometerSelecionados="descomprometerSelecionados"
                    ></btn-descomprometer-selecionados>
                    <btn-excluir-rateios-selecionados
                        :requisicao="requisicao"
                        :comprometimentosSelecionados="selecionadosParaExcluir"
                        @excluirRateiosSelecionados="excluirRateiosSelecionados"
                    ></btn-excluir-rateios-selecionados>
                </b-button-group>
            </template>
            <template slot="valor" slot-scope="data">{{
                data.valor | currency
            }}</template>
            <template slot="HEAD_comprometimentoSelecao">
                <i
                    class="
                        fa fa-check-square fa-lg
                        text-muted
                        icon-button
                        p-0
                        m-0
                    "
                    title="Marcar/Desmarcar todos"
                    @click.stop="marcarDesmarcarTodos()"
                    v-if="permiteMarcarRateios()"
                ></i>
            </template>
            <template slot="comprometimentoSelecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.idComprometimento"
                    v-model="comprometimentosSelecionados"
                    v-if="permiteMarcarRateios(data)"
                ></b-form-checkbox>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar-rateio-requisicao
                    :ref="`atualizarRateioRequisicao_${data.idComprometimento}`"
                    :requisicao="requisicao"
                    :comprometimento="data"
                    :erros="erros"
                    @atualizarRateio="atualizarRateio($event)"
                    v-if="permiteAtualizarRateio(data)"
                ></btn-atualizar-rateio-requisicao>
                <btn-excluir-rateio-requisicao
                    :comprometimento="data"
                    @excluirRateio="excluirRateio($event)"
                    v-if="permiteExcluirRateio(data)"
                ></btn-excluir-rateio-requisicao>
                <btn-visualizar-rateio-requisicao
                    :requisicao="requisicao"
                    :comprometimento="data"
                    v-if="permiteVisualizarRateio"
                ></btn-visualizar-rateio-requisicao>
                <btn-comprometer
                    :contrato="requisicao.contrato"
                    :comprometimento="data"
                    v-if="permiteComprometer(data)"
                    @comprometer="comprometer($event)"
                ></btn-comprometer>
                <btn-descomprometer
                    :contrato="requisicao.contrato"
                    :comprometimento="data"
                    v-if="permiteDescomprometer(data)"
                    @descomprometer="descomprometer($event)"
                ></btn-descomprometer>
                <btn-copiar
                    :contrato="requisicao.contrato"
                    :comprometimento="data"
                    v-if="permiteCopiar(data)"
                    @copiar="copiar($event)"
                ></btn-copiar>
                <btn-atualizar-movimento
                    :contrato="contrato"
                    :comprometimento="data"
                    :erros="erros"
                    v-if="permiteAtualizarRateio(data)"
                    @atualizarComprometimento="
                        $emit('obterRequisicaoAtualizada')
                    "
                ></btn-atualizar-movimento>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BtnInserirRateioRequisicao from './BtnInserirRateioRequisicao'
import RequisicoesServicos from './RequisicoesServicos'
import BtnAtualizarRateioRequisicao from './BtnAtualizarRateioRequisicao'
import BtnExcluirRateioRequisicao from './BtnExcluirRateioRequisicao'
import BtnVisualizarRateioRequisicao from './BtnVisualizarRateioRequisicao'
import BtnComprometer from './BtnComprometer'
import BtnDescomprometer from './BtnDescomprometer'
import BtnComprometerSelecionados from './BtnComprometerSelecionados'
import BtnDescomprometerSelecionados from './BtnDescomprometerSelecionados'
import BtnExcluirRateiosSelecionados from './BtnExcluirRateiosSelecionados'
import BtnCopiar from './BtnCopiar'
import BtnAtualizarMovimento from '../../comum/comprometimentos/BtnAtualizarMovimento.vue'

export default {
    components: {
        BtnInserirRateioRequisicao,
        BtnAtualizarRateioRequisicao,
        BtnExcluirRateioRequisicao,
        BtnVisualizarRateioRequisicao,
        BtnComprometer,
        BtnDescomprometer,
        BtnComprometerSelecionados,
        BtnDescomprometerSelecionados,
        BtnExcluirRateiosSelecionados,
        BtnCopiar,
        BtnAtualizarMovimento
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        requisicao: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        },

        requisicaoDisponivel: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            requisicaoComprometimentos: [],
            comprometimentosSelecionados: [],
            erros: [],
            erros2: [],
            campos: [
                {
                    key: 'comprometimentoSelecao',
                    label: '',
                    customHead: true
                },
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'vcTipoMovimento',
                    label: 'Movimento',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        marcarDesmarcarTodos() {
            if (this.comprometimentosSelecionados.length > 0) {
                this.comprometimentosSelecionados = []
            } else {
                this.comprometimentosSelecionados =
                    this.requisicaoComprometimentos
                        .filter((item) => {
                            return (
                                this.permiteComprometer(item) ||
                                this.permiteDescomprometer(item) ||
                                this.permiteExcluirRateio(item)
                            )
                        })
                        .map((item) => {
                            return item.idComprometimento
                        })
            }
        },

        inserirRateio(rateio) {
            this.$store.dispatch('addRequest')
            let rateioDto = {
                idRequisicao: this.requisicao.idRequisicao,
                itensComprometimento: rateio.itensRateios.map((item) => {
                    return {
                        idItemRequisicao: item.idItemRequisicao,
                        valorComprometimento: item.valorRateado
                    }
                }),
                rateios: rateio.rateios,
                historicoComprometimento: rateio.historicoComprometimento,
                dataComprometimento: rateio.dataComprometimento
            }
            RequisicoesServicos.inserirRateioRequisicao(rateioDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateio inserido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$refs.inserirRateioRequisicao.fecharModal()
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarRateio(rateio) {
            this.$store.dispatch('addRequest')
            let rateioDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: rateio.idComprometimento,
                itensComprometimento: rateio.itensRateios.map((item) => {
                    return {
                        idItemRequisicao: item.idItemRequisicao,
                        valorComprometimento: item.valorRateado
                    }
                }),
                rateios: rateio.rateios,
                historicoComprometimento: rateio.historicoComprometimento,
                dataComprometimento: rateio.dataComprometimento
            }
            RequisicoesServicos.atualizarRateioRequisicao(rateioDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateio atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$refs[
                                `atualizarRateioRequisicao_${rateioDto.idComprometimento}`
                            ].fecharModal()
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        excluirRateio(idComprometimento) {
            this.$store.dispatch('addRequest')
            let rateioDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: idComprometimento
            }
            RequisicoesServicos.excluirRateioRequisicao(rateioDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateio excluido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros2 = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        comprometer(idComprometimento) {
            this.$store.dispatch('addRequest')
            let comprometimentoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: idComprometimento
            }
            RequisicoesServicos.comprometer(comprometimentoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Comprometimento realizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros2 = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        comprometerSelecionados() {
            this.$store.dispatch('addRequest')
            let comprometimentosDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idContrato: this.requisicao.idContrato,
                comprometimentos: [...this.selecionadosParaComprometer]
            }
            RequisicoesServicos.comprometerSelecionados(
                comprometimentosDto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Comprometimentos realizados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.comprometimentosSelecionados = []
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.erros2 = response.errors
                        this.$emit('obterRequisicaoAtualizada')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        descomprometer(idComprometimento) {
            this.$store.dispatch('addRequest')
            let comprometimentoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: idComprometimento
            }
            RequisicoesServicos.descomprometer(comprometimentoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Descomprometimento realizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros2 = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        descomprometerSelecionados() {
            this.$store.dispatch('addRequest')
            let comprometimentosDto = {
                idsComprometimentos: [...this.selecionadosParaDescomprometer]
            }
            RequisicoesServicos.descomprometerSelecionados(
                comprometimentosDto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Descomprometimentos realizados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.comprometimentosSelecionados = []
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.erros2 = response.errors
                        this.$emit('obterRequisicaoAtualizada')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        excluirRateiosSelecionados() {
            this.$store.dispatch('addRequest')
            let rateiosDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idsComprometimentos: [...this.selecionadosParaExcluir]
            }
            RequisicoesServicos.excluirRateiosSelecionados(rateiosDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateios excluídos com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.comprometimentosSelecionados = []
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros2 = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        copiar(idComprometimento) {
            this.$store.dispatch('addRequest')
            let comprometimentoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idComprometimento: idComprometimento
            }
            RequisicoesServicos.copiar(comprometimentoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Copia realizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.erros2 = response.errors
                        this.$emit('obterRequisicaoAtualizada')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        permiteAtualizarRateio(rateio) {
            const situacaoSolicitacaoDevolvida = 3     
            return (
            (this.$temAcessoView('CONT-REQ-05') &&
                rateio.idSituacao == 1 &&
                this.requisicaoDisponivel) || this.requisicao.situacaoSolicitacao == situacaoSolicitacaoDevolvida
            )
        },

        permiteExcluirRateio(rateio) {
            const situacaoSolicitacaoDevolvida = 3     
            return (
                (this.$temAcessoView('CONT-REQ-05') &&
                rateio.idSituacao == 1 &&
                this.requisicaoDisponivel) || this.requisicao.situacaoSolicitacao == situacaoSolicitacaoDevolvida
            )
        },

        permiteComprometer(rateio) {    
            return (
                (this.$temAcessoView('CONT-REQ-05') &&
                this.requisicaoDisponivel &&
                rateio.idSituacao == 1)
            )
        },
        permiteMarcarRateios(rateio) {
            if (rateio) {
                return (
                    this.$temAcessoView('CONT-REQ-05') &&
                    this.requisicaoDisponivel &&
                    (this.permiteComprometer(rateio) ||
                        this.permiteDescomprometer(rateio) ||
                        this.permiteExcluirRateio(rateio))
                )
            }
            return (
                this.$temAcessoView('CONT-REQ-05') && this.requisicaoDisponivel
            )
        },

        permiteCopiar(rateio) {
            return (
                this.$temAcessoView('CONT-REQ-05') &&
                this.requisicaoDisponivel &&
                rateio.valor <= this.requisicao.saldoASerRateado
            )
        },

        permiteDescomprometer(rateio) {
            return (
                (this.$temAcessoView('CONT-REQ-05') &&
                this.requisicaoDisponivel &&
                (rateio.idSituacao == 4) &&
                rateio.statusIdRm != 'F' &&
                rateio.statusIdRm != 'Q') 
            )
        }
    },

    created() {},

    mounted() {
        this.requisicaoComprometimentos = [...this.requisicao.comprometimentos]
    },

    computed: {
        permiteInserirRateio() {
            return (
                (this.requisicao.saldoASerRateado > 0 &&
                this.$temAcessoView('CONT-REQ-05') &&
                this.requisicaoDisponivel)
            )
        },

        permiteVisualizarRateio() {
            return this.$temAcessoView('CONT-REQ-02')
        },

        selecionadosParaComprometer() {
            return this.requisicaoComprometimentos
                .filter((item) => {
                    return (
                        this.comprometimentosSelecionados.includes(
                            item.idComprometimento
                        ) && this.permiteComprometer(item)
                    )
                })
                .map((item) => {
                    return item.idComprometimento
                })
        },

        selecionadosParaDescomprometer() {
            return this.requisicaoComprometimentos
                .filter((item) => {
                    return (
                        this.comprometimentosSelecionados.includes(
                            item.idComprometimento
                        ) && this.permiteDescomprometer(item)
                    )
                })
                .map((item) => {
                    return item.idComprometimento
                })
        },

        selecionadosParaExcluir() {
            return this.requisicaoComprometimentos
                .filter((item) => {
                    return (
                        this.comprometimentosSelecionados.includes(
                            item.idComprometimento
                        ) && this.permiteExcluirRateio(item)
                    )
                })
                .map((item) => {
                    return item.idComprometimento
                })
        }
    },

    watch: {
        requisicao() {
            this.requisicaoComprometimentos = [
                ...this.requisicao.comprometimentos
            ]
        }
    }
}
</script>
